module.exports = __webpack_public_path__ + "img/banner-princiapal.b0163f0b.png";